import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(private http: HttpClient) {}

  get(url: string, options?: any): Observable<any> {
    return this.http.get(`${environment.baseUrl}/${url}`, options);
  }
  post(url: string, payload: any, options?: any): Observable<any> {
    return this.http.post(`${environment.baseUrl}/${url}`, payload, options);
  }
  put(url: string, payload: any, options?: any): Observable<any> {
    return this.http.put(`${environment.baseUrl}/${url}`, payload, options);
  }
  patch(url: string, payload: any, options?: any): Observable<any> {
    return this.http.patch(`${environment.baseUrl}/${url}`, payload, options);
  }
  delete(url: string, options?: any): Observable<any> {
    return this.http.delete(`${environment.baseUrl}/${url}`, options);
  }
  uploadPut(url: string, payload: any, options?: any): Observable<any> {
    return this.http.put(`${url}`, payload, options);
  }
}
